import { AuthToken, UserDetail } from '@core/models/auth.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { CONSTANTS } from './constants';
import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService, TokenResponse } from 'angular-oauth2-oidc';
import { BehaviorSubject, from, Observable } from 'rxjs';

import { StatehandlerService } from './statehandler.service';
import { Router } from '@angular/router';
@Injectable({ providedIn: 'root' })
export class AuthService {
  private headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
  private _authenticated: boolean = true;
  private readonly _authenticationChanged: BehaviorSubject<boolean> = new BehaviorSubject(this.authenticated);
  constructor(
    private oauthService: OAuthService,
    private authConfig: AuthConfig,
    private statehandler: StatehandlerService,
    private router: Router,
    private http: HttpClient

  ) {}

  async login(setState: boolean = true): Promise<boolean> {
    this.oauthService.configure(this.authConfig);

    this.oauthService.strictDiscoveryDocumentValidation = false;
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();

    this._authenticated = this.oauthService.hasValidAccessToken();

    if (!this.oauthService.hasValidIdToken() || !this.authenticated) {
      const newState = setState ? await this.statehandler.createState().toPromise() : undefined;
      this.oauthService.initCodeFlow(newState);
    }
    this._authenticationChanged.next(this.authenticated);

    return this.authenticated;
  }

  validateToken(token:string){
    var body = {"auth_token":token}; 
    this.http.post<any>('https://htm.sodexo.com/API/verify_token.php',body).subscribe(res => {
      this._authenticated = res.msg;
    });

    return this._authenticated;
  }

  logout() {
    this.oauthService.logOut();
    this._authenticated = false;
    this._authenticationChanged.next(false);

  }

  isLoggedIn() {
    // return this.getToken() ? true : false; // add your strong logic
    return this.oauthService.hasValidAccessToken();
  }

  getToken() {
    return localStorage.getItem("auth_token");
  }

  getIdToken() {
    return this.oauthService.getIdToken();
  }

  getName() {
    return this.getClaims()?.name;
  }

  getEmail() {
    return this.getClaims()?.email;
  }

  getPreferredUsername() {
    return this.getClaims()?.preferred_username;
  }

  getUserId() {
    return this.getClaims()?.sub;
  }

  getOrgId() {
    const claims = this.getClaims();

    return claims['urn:zitadel:iam:user:resourceowner:id'];
  }

  getOrgName(): any {
    const claims = this.getClaims();

    return claims['urn:zitadel:iam:user:resourceowner:name'];
  }

  getOrgPrimaryDomain(): any {
    const claims = this.getClaims();

    return claims['urn:zitadel:iam:user:resourceowner:primary_domain'];
  }

  getClaims(): any {
    let claims = this.oauthService.getIdentityClaims();
    console.log("this.oauthService.getIdentityClaims", claims)
    if (!claims) return null;

    return claims;
  }

  refreshToken(): Promise<TokenResponse> {
    return this.oauthService.refreshToken();
  }

  public get authenticated(): boolean {
    return this._authenticated;
  }

  public get authenticationChanged(): Observable<boolean> {
    return this._authenticationChanged;
  }

  public getOIDCUser(): Observable<any> {
    return from(this.oauthService.loadUserProfile());
  }

  public async authenticate(setState: boolean = true): Promise<boolean> {
    this.oauthService.configure(this.authConfig);

    this.oauthService.strictDiscoveryDocumentValidation = false;
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();

    this._authenticated = this.oauthService.hasValidAccessToken();

    if (!this.oauthService.hasValidIdToken() || !this.authenticated) {
      const newState = setState ? await this.statehandler.createState().toPromise() : undefined;
      this.oauthService.initCodeFlow(newState);
    }
    this._authenticationChanged.next(this.authenticated);
    console.log('authenticate', this.authenticated);

    return this.authenticated;
  }
}
